interface MaypoleIconProps {
  className?: string;
}

const MaypoleIcon = ({ className }: MaypoleIconProps) => (
  <svg
    viewBox="0 0 120 160"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    role="img"
  >
    {/* Pole */}
    <rect x="56" y="14" width="8" height="146" rx="3" fill="#16a34a" />
    {/* Birch garland wrapped around the pole */}
    <path
      d="M56 26 L64 34 M56 46 L64 54 M56 66 L64 74 M56 86 L64 94 M56 106 L64 114 M56 126 L64 134 M56 144 L64 152"
      stroke="#86efac"
      strokeWidth="3"
      strokeLinecap="round"
    />
    {/* Crossbar */}
    <rect x="18" y="34" width="84" height="7" rx="3.5" fill="#16a34a" />
    {/* Strings holding the wreaths */}
    <line x1="24" y1="41" x2="24" y2="52" stroke="#15803d" strokeWidth="2" />
    <line x1="96" y1="41" x2="96" y2="52" stroke="#15803d" strokeWidth="2" />
    {/* Wreaths */}
    <circle
      cx="24"
      cy="66"
      r="14"
      fill="none"
      stroke="#16a34a"
      strokeWidth="6"
    />
    <circle
      cx="96"
      cy="66"
      r="14"
      fill="none"
      stroke="#16a34a"
      strokeWidth="6"
    />
    {/* Flowers on the left wreath */}
    <circle cx="24" cy="52" r="3.5" fill="#facc15" />
    <circle cx="38" cy="66" r="3.5" fill="#f472b6" />
    <circle cx="24" cy="80" r="3.5" fill="#fff" />
    <circle cx="10" cy="66" r="3.5" fill="#facc15" />
    {/* Flowers on the right wreath */}
    <circle cx="96" cy="52" r="3.5" fill="#fff" />
    <circle cx="110" cy="66" r="3.5" fill="#facc15" />
    <circle cx="96" cy="80" r="3.5" fill="#f472b6" />
    <circle cx="82" cy="66" r="3.5" fill="#fff" />
    {/* Flower cluster on top */}
    <circle cx="60" cy="11" r="7" fill="#facc15" />
    <circle cx="51" cy="16" r="4.5" fill="#f472b6" />
    <circle cx="69" cy="16" r="4.5" fill="#fff" />
  </svg>
);

export default MaypoleIcon;
